export const getValueByKeys = (keys, object) => keys.reduce((prev, curr) => prev?.[curr], object);
